import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalManagerProspectsDocument = gql`
  query SalesPortalManagerProspects(
    $businessOrganizationUUID: uuid!
    $userTimezone: String!
    $employeeIds: [uuid!]!
    $stages: [ChatProspectStage!]!
  ) {
    getSalesPortalManagerProspectList(
      business_organization_id: $businessOrganizationUUID
      user_timezone: $userTimezone
      employee_ids: $employeeIds
      stages: $stages
    ) {
      currency_code
      last_activity_at
      owned_by_id
      owned_by_name
      restaurant_id
      restaurant_name
      stage
      supplier_id
      uuid
      weekly_estimated_value_in_micros
    }
  }
`;
export function useSalesPortalManagerProspectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >(SalesPortalManagerProspectsDocument, options);
}
export function useSalesPortalManagerProspectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >(SalesPortalManagerProspectsDocument, options);
}
export type SalesPortalManagerProspectsQueryHookResult = ReturnType<
  typeof useSalesPortalManagerProspectsQuery
>;
export type SalesPortalManagerProspectsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalManagerProspectsLazyQuery
>;
export type SalesPortalManagerProspectsQueryResult = Apollo.QueryResult<
  Types.SalesPortalManagerProspectsQuery,
  Types.SalesPortalManagerProspectsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalManagerProspectsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalManagerProspectsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >(SalesPortalManagerProspectsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalManagerProspectsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalManagerProspectsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalManagerProspectsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalManagerProspectsQuery,
    Types.SalesPortalManagerProspectsQueryVariables
  >(SalesPortalManagerProspectsDocument, lazyOptions);
}
